import { render, staticRenderFns } from "./DmWorkOrderModal.vue?vue&type=template&id=97e95e50&scoped=true"
import script from "./DmWorkOrderModal.vue?vue&type=script&lang=js"
export * from "./DmWorkOrderModal.vue?vue&type=script&lang=js"
import style0 from "./DmWorkOrderModal.vue?vue&type=style&index=0&id=97e95e50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e95e50",
  null
  
)

export default component.exports